var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col lg_flex-row lg_flex-wrap w-full h-screen absolute top-0 left-0"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full lg_w-1-2 bg-secondary-900 bg-cover items-center justify-center flex flex-col p-2 account-left",
          style: { backgroundImage: "url(" + _vm.bgImg + ")" }
        },
        [
          _c(
            "svg",
            {
              staticClass: "h-3 md_h-5",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 365.5 102.2"
              }
            },
            [
              _c("path", {
                staticClass: "fill-current text-white",
                attrs: {
                  d:
                    "M261.5 102.2c2.4-5.7 4.6-11 6.8-16.3.3-.8.3-1.8 0-2.6-3.9-10-7.9-20.1-11.8-30.1-.4-1.2-.9-1.7-2.2-1.6-1.9.1-3.7 0-5.9 0v35.2h-13.8V51.6H228V41.1h6.5V25.9h13.8V41h14c4.3 0 4.3 0 5.7 4.1l7.2 20.7c.1.4.3.8.7 1.6 2.3-7 4.5-13.6 6.7-20.1.7-2.1.9-4.9 2.4-6 1.4-1 4.1-.3 6.3-.3h8.1c-1.2 3.2-2.3 6.2-3.5 9.2-6.3 16.7-12.6 33.3-18.9 50-.5 1.4-1.1 2-2.7 1.9-4.1 0-8.3.1-12.8.1z"
                }
              }),
              _c("path", {
                staticClass: "fill-current text-primary",
                attrs: {
                  d:
                    "M153.4 86.7v-4.4c-7 8.9-21.2 6.9-28.1 1.2-11.5-9.5-11.8-31.3 1.7-40.1 5.5-3.6 11.5-4.8 18-3.2 3.3.8 6 2.6 8.3 5.7v-4.7H167v45.5h-13.6zM142 75.6c6.5 0 11.4-5 11.4-11.7 0-6.6-5-11.6-11.5-11.6-6.4 0-11.4 5.1-11.4 11.8.1 6.5 5.2 11.5 11.5 11.5z"
                }
              }),
              _c("path", {
                staticClass: "fill-current text-white",
                attrs: {
                  d:
                    "M365.1 68.2H331c.6 6.5 7.1 9 11.5 8.5 2.6-.3 4.7-1.4 6.4-3.3.4-.4 1.1-.9 1.6-.9 4-.1 7.9 0 11.9 0 .4 0 .8.1 1.2.1C361 81.1 350.3 90.7 337 88c-13.9-2.8-21.2-15.3-19.7-26.8C319.2 46.9 332 37.3 346 40c12.9 2.4 21.5 15 19.1 28.2zm-13.6-9.5c-.8-4.5-5.2-7.6-10.4-7.5-5 .1-9.1 3.2-9.8 7.5h20.2z"
                }
              }),
              _c("path", {
                staticClass: "fill-current text-primary",
                attrs: {
                  d:
                    "M23.9 40.2l15.9 15c.5.5.8 1.4 1.1 2.1 2 6 4.1 12 5.7 16.8 5-17.4 10.3-35.8 15.6-54.5 5.5 2 10.8 3.9 16.4 5.8 2-5 3.9-9.8 5.9-14.9-5-2.4-9.8-5-14.6-7.5 0-.1.1-.3.1-.4C78 5 86 7.4 94.3 9.9c-3.7 8.5-7.3 16.9-11.1 25.4-3.9-1.1-7.7-2.1-11.7-3.2-.3.8-.5 1.5-.8 2.2-5.6 17-11.2 33.9-16.7 50.8-.5 1.5-1.2 1.9-2.7 1.9-3.3-.1-6.6 0-9.8-.1-.6 0-1.6-.5-1.8-1C34.3 70.8 29 55.6 23.6 40.5l.3-.3z"
                }
              }),
              _c("path", {
                staticClass: "fill-current text-white",
                attrs: {
                  d:
                    "M191.6 73.2c4.4 0 8.6 0 12.7.1.5 0 1.2.7 1.4 1.2 1.3 3.6 6.9 3.4 8.7 1.5 1.3-1.4 1.3-3.3-.3-4.6-1.2-.9-2.6-1.6-4-2.1-2.6-1-5.2-1.9-7.9-2.9-.7-.3-1.5-.6-2.2-.9-10.8-5-9.1-16-2.8-21.4 7.5-6.4 20.4-5.9 26.9 1.1 2 2.2 3 4.6 3.6 8.9h-12.8c-.3 0-.7-.6-.9-1-1.2-2.4-4.8-3.1-6.8-1.4-1.5 1.3-1.5 3.3.4 4.4 2 1.2 4.3 2 6.6 2.8 2.6 1 5.3 1.7 7.9 2.8 8.8 3.8 8.7 14.1 4.7 19.5-4.7 6.4-11.5 7.9-18.9 7.2-4.5-.4-8.7-2-11.9-5.5-2.7-2.7-3.8-5.9-4.4-9.7zM39.8 49c-.9-.8-1.3-1.2-1.8-1.6-4.6-4.3-9.3-8.5-13.9-12.8-1-.9-1.8-1.1-3-.7-3.3 1-6.5 1.9-10.1 2.8-3.6-8.3-7.2-16.5-11-24.9.9-.4 1.7-.8 2.5-1.2C9.8 7.4 17 4.2 24.3 1.1c1.5-.6 3.2-.9 4.8-1 3.3-.2 6.6 0 10 0 .8 5.1 2.6 9.6 8.6 10 4.2.3 7.5-2.6 9.5-7.8 1.1 5.3-2.6 11.1-7.8 13-6.8 2.5-13.6.2-16.5-5.8-3-.3-5.8 0-8.5 1.4-4 2-8.3 3.7-12.5 5.6 1.1 2.9 2.2 5.7 3.4 8.4.2.4 1.3.8 1.8.7 4.3-1.1 8.7-2.3 13-3.6 1.5-.4 2.1-.3 2.5 1.3 2.2 8 4.5 16 6.8 24 .2.4.2.8.4 1.7z"
                }
              }),
              _c("path", {
                staticClass: "fill-current text-primary",
                attrs: { d: "M172.9 26h13.4v60.8h-13.4V26z" }
              }),
              _c("path", {
                staticClass: "fill-current text-white",
                attrs: { d: "M313.8 86.8h-13.5V25.9h13.5v60.9z" }
              }),
              _c("path", {
                staticClass: "fill-current text-primary",
                attrs: {
                  d:
                    "M93.1 86.8V41.2h12.8v4c2.9-4.1 6.8-5.6 11.7-5.6 0 4.4 0 8.7-.1 12.9 0 .3-.8.8-1.2.9-1.2.2-2.4.2-3.6.5-4 .8-5.9 3.1-5.9 7.1-.1 7.8 0 15.7 0 23.5v2.3H93.1zM87.5 86.9H75.3c-.4 0-.8 0-1.3-.1V41.3h13.5v45.6z"
                }
              })
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "text-sm lg_text-2xl text-white fulfillment-text mt-_5 select-none"
            },
            [_vm._v("FULFILLMENT")]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "w-full lg_w-1-2 dark-mode_bg-secondary bg-gray-100 items-center justify-center flex account-right flex-grow lg_flex-grow-0"
        },
        [_vm.$route.name === "register" ? _c("register") : _c("login")],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }